import { AccountClient } from '@frontend/account/api';
import { EntityType } from '@frontend/common';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useAccount:request': CustomEvent<string>;
    }
}

const REQUEST_ACCOUNT_EVENT = 'useAccount:request';
const STORAGE_KEY = 'ACS_REQ';

export function accountRequest(accountId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_ACCOUNT_EVENT, { detail: accountId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function AccountResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_ACCOUNT_EVENT, EntityType.ACCOUNT, (ids) => AccountClient.resolveAccounts(ids), props.dispatch);
    return <></>;
}
